module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn call_statistics"
  }, [_c('filters', {
    staticClass: "filter-call_statistics",
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": _vm.title
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e239866"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/CallStatistics.vue
// module id = 576
// module chunks = 0